import { tagAnatomy as l } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as n, defineStyle as e } from "@chakra-ui/styled-system";
const { defineMultiStyleConfig: a, definePartsStyle: s } = n(l.keys), i = e({
  px: 2,
  borderRadius: "lg",
  outline: 0,
  gap: "4px",
  _focusVisible: {
    boxShadow: "outline"
  }
}), r = e({
  textStyle: "bodyBoldSmall",
  overflow: "visible"
}), c = e({
  height: "14px",
  width: "14px",
  minW: "14px",
  minH: "14px"
}), b = s({
  container: i,
  label: r,
  closeButton: c
}), u = e((o) => {
  const { colorScheme: t, theme: m } = o;
  return {
    container: {
      bg: `${t}.100`
    },
    label: {
      color: `${t}.800`
    }
  };
}), S = {
  subtle: u
}, d = a({
  variants: S,
  baseStyle: b,
  defaultProps: {
    variant: "subtle",
    colorScheme: "teal"
  }
});
export {
  d as default
};
